import { SourceDatabase } from './elements';

//The project was meant to have 4 differentes components databases. User, system and course
//Due to high complexity it was postponed to the next stage but the support for associating components to a source is here already
export const sourceDatabase: SourceDatabase = {
  sourceType: 'SYSTEM',
  sourceId: 'ad51df0b-d350-4fd6-a7cb-904a938e7bbb',
};

/**
 * Component Database Additional Check
 * 
 * This function performs an additional check for component database items based on the user's role in the table for the column actions.
 * It restricts access for "STUDENT" users, allowing them to only interact with components where the `sourceType` is "USER".
 * 
 * @param {Object} row - The current row data being checked.
 * @param {string} userRole - The role of the current user (e.g., "STUDENT", "LECTURER").
 * 
 * @returns {boolean} - Returns `true` if the user has access to the row, otherwise `false` for "STUDENT" users with non-"USER" `sourceType`.
 */
export const compDBAdditionalCheck = ({ row }: any, userRole: any) => {
  if (userRole === 'STUDENT') return row.sourceType === 'USER';
  else return true;
};
